<template>
  <div class="contentBox">
    <div class="logo-item clear">
      <div class="logo-txt">
        <i class="icon icon-logo"></i>
        <p>Speakio</p>
      </div>
      <div class="logo-nav">
        <button class="btn btn-nav btn-nav1 select">
          <router-link router-link to="/index">Features</router-link>
        </button>
        <button class="btn btn-nav btn-nav2">
          <router-link router-link to="/contact">Contact</router-link>
        </button>
      </div>
    </div>

    <div class="item item1">
      <div class="item-title-img" ref="bannerImg" :style="{ height: imgHeight + 'px','background-size': '100% ' + imgHeight + 'px'}">
          <div class="item-title-upload">
            <p>Available for download :</p>
            <div class="item-title-upliad-app">
              <div class="item-app item-Ios">
                <i class="icon icon-ios"></i>
                <p>App Store</p>
              </div>
              <div class="item-app item-Android">
                <i class="icon icon-Android"></i>
                <p>Play Store</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="item item-cont item2">
      <div class="item-title-img" :style="{ height: imgHeight + 'px','background-size': '100% ' + imgHeight + 'px'}"></div>
    </div>
    <div class="item item-cont item3">
      <div class="item-title-img" :style="{ height: imgHeight + 'px','background-size': '100% ' + imgHeight + 'px'}"></div>
    </div>
    <div class="item item-cont item4">
      <div class="item-title-img" :style="{ height: imgHeight + 'px','background-size': '100% ' + imgHeight + 'px'}"></div>
    </div>
    <div class="item item-cont item5">
      <div class="item-title-img" :style="{ height: imgHeight + 'px','background-size': '100% ' + imgHeight + 'px'}"></div>
    </div>
     <div class="item item-cont item6">
      <div class="item-title-img" :style="{ height: imgHeight + 'px','background-size': '100% ' + imgHeight + 'px'}"></div>
    </div>

    <footer class="footer">
      <div class="footer-btnBox">
        <router-link to="/contact">Contact</router-link>
        <router-link to="/text?type=4">Terms of Service</router-link>
        <router-link to="/text?type=2">Privacy Policy</router-link>
      </div>
      <p>Copyright @ 2026 Speakio. All Rights Reserved</p>
    </footer>
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
      imgHeight: 0,
      imgHeight1: 0,
      imgHeight2: 0,
      
    };
  },
  mounted(){
    this.imgHeight = this.$refs.bannerImg.offsetWidth / 2.7;
    this.imgHeight1 = this.$refs.bannerImg1.offsetWidth / 2.7;
    this.imgHeight2 = this.$refs.imgHeight2.offsetWidth / 2.7;
  },
  methods: {
    
  }
};
</script>
<style scoped>
  .contentBox{
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #E5CFFF;
  }

  .logo-item{
    display: block;
    box-sizing: border-box;
    padding: 10px 100px;
    background-color: rgba(255, 255, 255, .43);
  }

  .logo-item .logo-txt{
    float: left;
  }

  .logo-item .logo-txt .icon-logo{
    background-image: url(~@/assets/images/index-icon10.png);
    width: 60px;
    height: 60px;
    background-size: 60px 60px;
    display: inline-block;
    vertical-align: middle;
  }

  .logo-item .logo-txt p{
    font-size: 18px;
    color: #000000;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
  }

  .logo-item .logo-nav{
    float: right;
  }

  .logo-item .logo-nav a{
    text-decoration: none;
    color: #333333;
  }

  .logo-item .logo-nav .btn{
    font-size: 18px;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 15px 0;
  }
  
  .logo-item .logo-nav .btn.select{
    color: #6E2FFF;
    border-bottom: solid 3px #6E2FFF;
  }

  .logo-item .logo-nav .btn.btn-nav2{
    margin-left: 50px;
  }

  .item1{
    background-color: #E5CFFF;
    box-sizing: border-box;
    padding: 100px;
  }

  .item-title-img{
    background-image: url(~@/assets/images/index-icon1.png);
    width: 100%;
    height: auto;
    background-size: 100% 100%;
    position: relative;
  }

  .item-title-upload{
    background-color: #fff;
    border-radius: 40px;
    box-sizing: border-box;
    padding-bottom: 70px;
    margin-top: 128px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .item-title-upload p{
    background-color: #CDB8FF;
    width: 328px;
    height: 74px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    color: #000000;
    font-size: 24px;
    box-sizing: border-box;
    padding: 20px 30px;
    margin: 0 auto;
  }

  .item-title-upliad-app{
    font-size: 0;
    margin-top: 40px;
    text-align: center;
    padding: 0 50px;
    box-sizing: border-box;
  }

  .item-title-upliad-app .item-app{
    width: 297px;
    height: 95px;
    background-color: #333333;
    border-radius: 20px;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 25px 0;
    margin: 0 10px;
  }

  .item-title-upliad-app .item-app .icon{
    background-image: url(~@/assets/images/index-icon3.png);
    width: 45px;
    height: 45px;
    background-size: 45px 45px;
    display: inline-block;
    vertical-align: top;
  }

  .item-title-upliad-app .item-app .icon-ios{
    background-image: url(~@/assets/images/index-icon2.png);
  }

  .item-title-upliad-app .item-app p{
    font-size: 32px;
    color: #FFFFFF;
    display: inline-block;
    vertical-align: top;
    background-color: transparent;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
  }

  .item-cont{
    box-sizing: border-box;
    padding: 167px 100px;
  }

  .item5,
  .item3{
    background-color: #EFEEF3;
  }

  .item6,
  .item4,
  .item2{
    background-color: #F5F4F7;
  }

  .item2 .item-title-img{
    background-image: url(~@/assets/images/index-icon4.png);
  }

  .item4 .item-title-img{
    background-image: url(~@/assets/images/index-icon6.png);
  }

  .item6 .item-title-img{
    background-image: url(~@/assets/images/index-icon9.png);
  }

  .item3 .item-title-img{
    background-image: url(~@/assets/images/index-icon5.png);
  }

  .item5 .item-title-img{
    background-image: url(~@/assets/images/index-icon7.png);
  }

  .item7 .item-title-img{
    background-image: url(~@/assets/images/index-icon9.png);
  }

  footer{
    background-color: #260054;
    display: block;
    text-align: center;
    box-sizing: border-box;
    padding: 80px 0;
  }

  footer .footer-btnBox{
    font-size: 0;
    text-align: center;
    margin-bottom: 30px;
  }

  footer .footer-btnBox a{
    color: #FFFFFF;
    font-size: 18px;
    display: inline-block;
    vertical-align: top;
    border-right: solid 1px #fff;
    padding: 0 10px;
    text-decoration: none;
  }

  footer .footer-btnBox a:last-child{
    border-right: none;
  }

  footer p{
    color: #FFFFFF;
    font-size: 16px;
  }

  footer p:nth-of-type(2){
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/index/index.vue